import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VisitsState, VisitStatusUpdatePayload } from './interfaces';
import { LoadVisitsPayload, LoadVisitsRecordingStatPayload } from './interfaces';
import { VisitStatusesUpdatePayload } from '../visits/interfaces';
import { updateNoteTemplateRequested } from '../provider';
import { UpdateNoteTemplatePayload } from '../provider/interfaces';
import { NOTE_STATUS } from '@ax/constants';

const initialState: VisitsState = {
  items: [],
  recordings: {},
};

export const visitsSlice = createSlice({
  name: 'visits',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(
      updateNoteTemplateRequested,
      (state, action: PayloadAction<UpdateNoteTemplatePayload>) => {
        return {
          ...state,
          items: state.items.map((visit) => {
            if (visit.uuid === action.payload.noteId && action.payload.regenerateNote) {
              return {
                ...visit,
                isProcessing: true,
              };
            }

            return {
              ...visit,
            };
          }),
        };
      },
    );
  },
  reducers: {
    loadVisitsSucceeded(state, action: PayloadAction<LoadVisitsPayload>) {
      return {
        ...state,
        items: action.payload.visits ?? [],
        date: action.payload.date,
      };
    },
    loadVisitsRecordingsSucceeded(state, action: PayloadAction<LoadVisitsRecordingStatPayload>) {
      state.recordings = action.payload.stats;
      return state;
    },
    visitStatusesUpdateRequested(state, _: PayloadAction<VisitStatusesUpdatePayload>) {
      return state;
    },
    visitStatusUpdateSucceeded(state, action: PayloadAction<VisitStatusUpdatePayload>) {
      const { visitId, status } = action.payload;
      const visit = state.items.find((visit) => visit.uuid === visitId);

      if (visit) {
        visit.noteStatus = status;

        if (status !== NOTE_STATUS.CONTENT_PROCESSING) {
          visit.isProcessing = false;
        }
      }

      return state;
    },
    visitStatusUpdateFailed(state, _: PayloadAction<VisitStatusUpdatePayload>) {
      return state;
    },
    visitRecordingStarted(state, _: PayloadAction<{ visitId: string }>) {
      return state;
    },
    visitRecordingStopped(state, action: PayloadAction<{ visitId: string }>) {
      const visit = state.items.find((visit) => visit.uuid === action.payload.visitId);

      if (visit) {
        visit.isProcessing = true;
      }

      return state;
    },
  },
});

export const {
  loadVisitsSucceeded,
  loadVisitsRecordingsSucceeded,
  visitStatusesUpdateRequested,
  visitStatusUpdateSucceeded,
  visitStatusUpdateFailed,
  visitRecordingStarted,
  visitRecordingStopped,
} = visitsSlice.actions;

export default visitsSlice.reducer;
